import { render, staticRenderFns } from "./AffiliatesTable.vue?vue&type=template&id=48413802&scoped=true&"
import script from "./AffiliatesTable.vue?vue&type=script&lang=js&"
export * from "./AffiliatesTable.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatesTable.vue?vue&type=style&index=0&id=48413802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48413802",
  null
  
)

export default component.exports